import React from 'react'

interface FormHeaderProps {
  templateName?: String
  templateId?: String
  onSampleClick: () => void
}

export default function FormHeader({ templateName, onSampleClick }: FormHeaderProps) {
  return (
    <div className="flex justify-between items-center mb-1">
      <div className="text-left text-lg font-bold">{templateName}</div>
      <div className="text-sm cursor-pointer lg:hidden" style={{ color: '#4086FF' }} onClick={onSampleClick}>
        示例报告
      </div>
    </div>
  )
}
